import { get, post, put, downloadBlob, destroy } from '../lib/api';
import { makeGrowerPath } from '../lib/api/utils';

export function validateFields(aaids) {
  return post(
    makeGrowerPath(`/starter-fertilizer/fields/validity`),
    aaids,
  ).catch((e) =>
    aaids.map((aaid) => ({ aaid, isValid: false, reason: e.message })),
  );
}

export function getFields(growerId) {
  return get(`/${growerId}/starter-fertilizer/fields`);
}

export function getPrescriptions(growerId) {
  return get(`/${growerId}/starter-fertilizer/prescriptions`);
}

export function getPrescription(growerId, id) {
  return get(`/${growerId}/starter-fertilizer/prescriptions/${id}`);
}

export function updateApplied(growerId, id, isApplied) {
  return put(`/${growerId}/starter-fertilizer/prescriptions/${id}`, {
    isApplied,
  });
}

export function downloadPrescriptionShapefiles(growerId, prescriptions) {
  return downloadBlob(
    `/${growerId}/starter-fertilizer/prescriptions/shapefiles?ids=${prescriptions
      .map((p) => p.id)
      .join(',')}`,
  );
}

export function downloadFieldShapefiles(growerId, fields) {
  return downloadBlob(
    `/${growerId}/starter-fertilizer/fields/shapefiles?ids=${fields
      .map((p) => p.id)
      .join(',')}`,
  );
}

export function downloadFieldPdfs(growerId, fields) {
  return downloadBlob(
    `/growers/${growerId}/starter-fertilizer/pdf/field?ids=${fields.map((f) => f.id).join(',')}`,
  );
}

export function downloadPrescriptionPdfs(growerId, prescriptions) {
  return downloadBlob(
    `/growers/${growerId}/starter-fertilizer/pdf/prescription?ids=${prescriptions.map((p) => p.id).join(',')}`,
  );
}

export function previewAdjustments(growerId, id, adjustments) {
  return post(
    `/${growerId}/starter-fertilizer/prescriptions/${id}/adjustment`,
    adjustments,
  );
}

export function saveAdjustments(growerId, id) {
  return post(`/${growerId}/starter-fertilizer/adjustments/${id}`);
}

export function deletePrescriptions(growerId, prescriptions) {
  return destroy(
    `/${growerId}/starter-fertilizer/prescriptions?ids=${prescriptions
      .map((p) => p.id)
      .join(',')}`,
  );
}

export function formatSelectedFieldsData(selectedFields) {
  return selectedFields.flatMap((f) =>
    f.prescriptions
      .filter((p) => p.isApplied)
      .flatMap((p) => ({
        field_name: f.name,
        farm_name: f.farmName,
        acres: f.acres.toFixed(2),
        planned_crop: f.crop,
        prescription_name: p.name,
        average_gallons: mapPrescriptionFields(p, f, 'avgGallons'),
        fulfilled: mapPrescriptionFields(p, f, 'fulfilledPercentage'),
        '<10': mapPrescriptionFields(p, f, 'underFulfilledPercentage'),
        '>10': mapPrescriptionFields(p, f, 'overFulfilledPercentage'),
        applied: p.isApplied,
      })),
  );

  function mapPrescriptionFields(prescription, currentField, attribute) {
    const field = prescription.fields.find(
      (f) => f.fieldName === currentField.name,
    );

    return field[attribute].toFixed(2);
  }
}
